import React from 'react';
import LabTabs from './components/CustomTab';
import Box from '@mui/material/Box';
import { useAuth } from 'oidc-react';
import LoadingSpinner from './components/LoadingSpinner';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { FavoritesProvider } from './context/FavoritesContext';
import { useFavoritesEvents } from './hooks/useFavoritesEvents';

// Create a QueryClient
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      refetchOnWindowFocus: false,
    },
  },
});

const App: React.FC = () => {
  const auth = useAuth();
  useFavoritesEvents(queryClient);

  if (auth.isLoading || !auth.userData?.id_token) {
    return <LoadingSpinner />;
  } else {
    console.log('User is logged in');
  }

  return (
    <QueryClientProvider client={queryClient}>
      <FavoritesProvider>
        <Box
          sx={{
            width: '100%',
            maxWidth: 'none',
            margin: '0 auto',
            boxSizing: 'border-box',
          }}>
          <LabTabs customerId={1} />
        </Box>
      </FavoritesProvider>
    </QueryClientProvider>
  );
};

export default App;
